import routerSlice from 'src/store/router/slice'

export const setQueryParamCreator = param => value => dispatch => {
  dispatch(routerSlice.actions.setQueryParam({ param, value }))
}
